import script from "./SocialsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialsModal.vue?vue&type=script&setup=true&lang=js"

import "./SocialsModal.vue?vue&type=style&index=0&id=5d2ef4d5&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2ef4d5"]])

export default __exports__